import { inject, Injectable, signal } from '@angular/core';
import { StorageService } from 'ngx-lib';

const STORAGE_KEY = 'side-nav-expanded';

interface SideNavState {
    expanded: boolean;
}

@Injectable({ providedIn: 'root' })
export class SideNavService {
    isOpen = signal(false);

    private readonly storage = inject(StorageService);

    constructor() {
        /** Initial state from localStorage, or false by default if no saved value */
        this.isOpen = signal(this.storage.getItem<SideNavState>(STORAGE_KEY)?.expanded ?? false);
    }

    toggle(): void {
        this.isOpen.update((state) => {
            const newState = !state;
            this.storage.setItem(STORAGE_KEY, { expanded: newState });
            return newState;
        });
    }
}
